
export const handleUserKeyPress = (event, audio) => {
  const keyCode = event.keyCode;
  const shiftKey = event.shiftKey;
  const ctrlKey = event.ctrlKey;
  if (!(shiftKey || ctrlKey)) {
    if (keyCode === 32 || keyCode === 75 || keyCode === 80) {
      audio.playPause();
    }
    if (keyCode == 77) {
      audio.setMute(!audio.getMute());
    }
    if (keyCode === 76 || keyCode === 39) {
      if (event.getModifierState("CapsLock")) {
        audio.setCurrentTime(audio.getCurrentTime() + 30);
      } else {
        audio.setCurrentTime(audio.getCurrentTime() + 10);
      }
    }
    if (keyCode === 74 || keyCode === 37) {
      if (event.getModifierState("CapsLock")) {
        if (audio.getCurrentTime() >= 30) {
          audio.setCurrentTime(audio.getCurrentTime() - 30);
        } else {
          audio.setCurrentTime(0);
        }
      } else {
        if (audio.getCurrentTime() >= 10) {
          audio.setCurrentTime(audio.getCurrentTime() - 10);
        } else {
          audio.setCurrentTime(0);
        }
      }
    }
    if (keyCode == 107 || keyCode == 38) {
      if (audio.getVolume() <= 0.8) {
        audio.setVolume(audio.getVolume() + 0.2);
      } else {
        audio.setVolume(1);
      }
    }
    if (keyCode == 109 || keyCode == 40) {
      if (audio.getVolume() >= 0.2) {
        audio.setVolume(audio.getVolume() - 0.2);
      } else {
        audio.setVolume(0);
      }
    }
  }
};
